import { Editable, EditableInput, EditablePreview } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import PlanPermission from 'container/PlanPermission';
import {
  PLAN_REVAMP_RADIUS_SM,
  accent,
  fontSize,
  neutral,
  text as textToken,
} from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';

interface Properties {
  defaultValue: string;
  onSubmit: (value: string) => void;
  isEditNameMode?: boolean;
  planPermission: boolean;
  closeEditMode?: () => void;
}

const EditableField = ({
  defaultValue,
  onSubmit,
  planPermission,
  isEditNameMode,
  closeEditMode,
}: Properties) => {
  const [value, setValue] = useState(defaultValue || '');
  useEffect(() => {
    setValue(defaultValue || '');
  }, [defaultValue]);

  const submitValue = (itemValue: string) => {
    onSubmit(itemValue);
  };
  const onChange = (itemValue: string) => {
    setValue(itemValue);
  };

  return (
    <Editable
      overflow='hidden'
      value={value}
      onChange={onChange}
      onSubmit={submitValue}
      startWithEditView={isEditNameMode}
      onBlur={closeEditMode}
      h='30px'
      w={isEditNameMode ? 'full' : '76px'}
      border='1px solid'
      borderRadius={PLAN_REVAMP_RADIUS_SM}
      borderColor={neutral.border}
      bg={neutral.surface}
      p='0'
      fontSize={fontSize.body}
      color={textToken.primary}
      display='flex'
      alignItems='center'
      justifyContent='center'
      textAlign={isEditNameMode ? 'start' : 'center'}
      cursor={planPermission ? 'not-allowed' : 'pointer'}
      isDisabled={!!planPermission}
      transition='border-color 0.12s ease'
      _hover={{ borderColor: neutral.borderStrong }}
    >
      <EditablePreview
        w='full'
        h='full'
        display='flex'
        alignItems='center'
        justifyContent='inherit'
        px='8px'
        cursor={planPermission ? 'not-allowed' : 'pointer'}
      />
      <EditableInput
        px='8px'
        cursor={planPermission ? 'not-allowed' : 'pointer'}
        _focusVisible={{
          h: 'full',
          px: '8px',
          border: '1px solid',
          borderRadius: PLAN_REVAMP_RADIUS_SM,
          borderColor: accent.solid,
          boxShadow: 'none',
        }}
      />
    </Editable>
  );
};

export default PlanPermission(EditableField);
